<template>
  <div>
    <sys-data-table
      v-model="itensSelecionados"
      :items="itens"
      :itemHeight="35"
      :headers="headers"
      :loading="loadingTable"
      :height="alturaDaJanela - 250"
      show-select
      fixed-header
      item-key="id"
      desativar_ordenacao
      class="elevation-2 table-full-screen"
      @click:th="() => abrir_dialog_ordenacao_count++"
      @scroll-items="buscarProdutosSeTiverNoFinalDaRolagem($event)"
    >
      <template v-slot:top>
        <Ordenacao
          :id_unico_preferencia="id_unico_preferencia"
          :itens="colunas_ordenacao"
          :abrir_dialog_ordenacao_count="abrir_dialog_ordenacao_count"
          @update:ordenacao="() => resetarCarregamentoProdutos()"
          @campos:ordenacao="atualizarCamposOrdenados"
        />

        <v-toolbar flat color="white" height="60px">
          <v-icon class="mr-1">mdi-format-list-bulleted</v-icon>
          <span class="font-17">Lista de produtos silenciados</span>

          <v-spacer />

          <div style="width: 450px">
            <v-text-field
              class="mr-5"
              v-model="pesquisa"
              append-icon="mdi-magnify"
              label="Pesquisar"
              single-line
              hide-details
              clearable
              @change="resetarCarregamentoProdutos()"
              @keypress.enter="resetarCarregamentoProdutos()"
            />
          </div>

          <v-btn v-if="itensSelecionados.length > 0" color="red" dark class="mr-2" @click="excluir()">
            <v-icon left>mdi-delete</v-icon>
            apagar ({{ itensSelecionados.length }})
          </v-btn>

          <div class="w-180">
            <SysFilialGrupoAutocomplete
              v-model="filial"
              :id-grupo="grupoCompras"
              label="Filtro de Filiais"
              outlined
              dense
              multiple
              class="mr-1"
              hide-details
              :qtde-visivel-selecionados="1"
              height="10"
              @change="resetarCarregamentoProdutos()"
              @blur="resetarCarregamentoProdutos()"
            />
          </div>

          <ExportacaoGridParaExcel
            url="relatorios/drp/produtos-silenciados"
            :items="itens"
            :parametros_excel="headers"
          />

          <ImportProdutosASilenciar @atualizar-listas="todosItensPaginadosCarregados = false; listar();"/>

          <v-dialog persistent v-model="dialog" max-width="600px" content-class="bra-20">
            <template v-slot:activator="{ on }">
              <v-btn color="primary" dark v-on="on">
                <v-icon left>mdi-plus</v-icon>
                Novo
              </v-btn>
            </template>

            <v-card>
              <v-card-title>
                <span class="font-19 font-weight-medium">Silenciar produtos</span>

                <v-spacer />

                <v-btn icon class="" @click="fechar">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>

              <v-divider />

              <v-card-text class="mt-7">
                <SysGrupoAutocomplete
                  v-model="form.grupo"
                  :items="selects.grupo"
                  label="Grupo Compras"
                  outlined
                  :error-messages="mensagensErros('grupo')"
                  @input="$v.form.grupo.$touch()"
                />

                <SysFilialGrupoAutocomplete
                  v-model="form.filial"
                  :id-grupo="form.grupo"
                  label="Selecione Filial"
                  outlined
                  multiple
                  :error-messages="mensagensErros('filial')"
                  @input="$v.form.filial.$touch()"
                />

                <v-select
                  v-model="form.tipo"
                  :items="selects.tipo"
                  label="Selecione tipo de Execução"
                  outlined
                  :error-messages="mensagensErros('tipo')"
                  @input="$v.form.tipo.$touch()"
                ></v-select>

                <template v-if="form.tipo === 1">
                  <sys-produto-autocomplete
                    v-model="form.pesquisa"
                    :grupo="form.grupo"
                    label="Selecione o Produto"
                    clearable
                    outlined
                    multiple
                    :error-messages="mensagensErros('pesquisa')"
                    @input="$v.form.pesquisa.$touch()"
                  ></sys-produto-autocomplete>
                </template>

                <template v-if="form.tipo === 2">
                  <v-autocomplete
                    v-model="form.pesquisa"
                    :items="selects.pesquisa"
                    label="Selecione o Fornecedor"
                    clearable
                    outlined
                    multiple
                    :error-messages="mensagensErros('pesquisa')"
                    @input="$v.form.pesquisa.$touch()"
                  ></v-autocomplete>
                </template>

                <template v-if="form.tipo === 3">
                  <v-autocomplete
                    v-model="form.pesquisa"
                    :items="selects.pesquisa"
                    label="Selecione o Segmento"
                    clearable
                    outlined
                    multiple
                    :error-messages="mensagensErros('pesquisa')"
                    @input="$v.form.pesquisa.$touch()"
                  ></v-autocomplete>
                </template>
              </v-card-text>

              <v-card-actions class="mt-n3">
                <v-spacer></v-spacer>

                <v-btn text color="primary" @click="salvar">Salvar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>

      <template v-for="(item, key) in campos_em_ordenacao" #[`header.${item.campo}.icon_order`]>
        <span :key="key">
          <v-icon v-if="item.ordem === 'DECRESCENTE'" small v-text="'mdi-arrow-down'" />
          <v-icon v-else small v-text="'mdi-arrow-up'" />
        </span>
      </template>

      <template v-slot:item.icon_acoes="{ item }">
        <v-btn icon title="Excluir Produto" @click="excluir({id: item.id})">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>

      <template #footer>
        <v-spacer />
        <span class="font-12 text-gray-800 py-2 pr-3 pl-3">Total de Itens: {{ itens.length }} de {{ countTotal }}</span>
      </template>
    </sys-data-table>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import SysProdutoAutocomplete from "../../utils/crud/SysProdutoAutocomplete";
import SysFilialGrupoAutocomplete from "@/components/utils/crud/SysFilialGrupoAutocomplete";
import SysGrupoAutocomplete from "@/components/utils/crud/SysGrupoAutocomplete";
import {buscarFornecedores, salvarSilenciamentoProdutos, buscarProdutosSileciados, excluirProdutosSileciados, buscarSegmentos} from '@/api/drp/blacklist.js'
import {arrayColumn, logout} from "@/helpers";
import ExportacaoGridParaExcel from "@/components/utils/ExportacaoGridParaExcel.vue";
import ImportProdutosASilenciar from "./ImportProdutosASilenciar.vue";
import Responsividade from '@/helpers/ResponsiveHeight';
import Ordenacao from "@/components/utils/dataTable/Ordenacao.vue";
import {mapGetters} from "vuex";

export default {
  components: {
    SysGrupoAutocomplete,
    SysFilialGrupoAutocomplete,
    SysProdutoAutocomplete,
    ExportacaoGridParaExcel,
    ImportProdutosASilenciar,
    Ordenacao
  },
  mixins: [Responsividade],
  props: ["atualizarPedido", "atualizar_produtos_silenciados_count"],
  data() {
    return {
      filial: '',
      search: "",
      selects: {
        pesquisa: [],
        filial: [],
        grupo: [],
        tipo: [
          { value: 1, text: "1 - Aplicar no Produto" },
          { value: 2, text: "2 - Aplicar no Fornecedor" },
          { value: 3, text: "3 - Aplicar no Segmento" },
        ],
      },
      form: {
        grupo: '',
        filial: [],
        tipo: '',
        pesquisa: '',
      },
      headers: [
        { text: "ID", value: "id", align: "center" },
        { text: "Filial", value: "filial", align: "center" },
        { text: "ID Produto", value: "idproduto", align: "center" },
        { text: "Descrição produto", value: "descricao_produto" },
        { text: "Usuário", value: "log_user" },
        { text: "Data", value: "log_data", align: "center" },
        {
          text: "Acões",
          value: "icon_acoes",
          sortable: false,
          width: "60px",
          align: "center",
        },
      ],
      colunas_ordenacao: [
        { descricao: "ID", campo: "id", },
        { descricao: "Filial", campo: "filial", },
        { descricao: "ID Produto", campo: "idproduto", },
        { descricao: "Descrição produto", campo: "descricao_produto" },
        { descricao: "Usuário", campo: "log_user" },
        { descricao: "Data", campo: "log_data", },
      ],
      itens: [],
      itensSelecionados: [],
      dialog: false,
      itensPorPagina: 300,
      pesquisa: '',
      timerScrollDataTable: null,
      timerPesquisaKeyPress: null,
      loadingTable: false,
      todosItensPaginadosCarregados: false,
      abrir_dialog_ordenacao_count: 0,
      campos_em_ordenacao: [],
      id_unico_preferencia: 'ORDENACAO_TABELA_DRP_PRODUTOS_SILENCIADOS',
      countTotal: 0
    };
  },
  validations: {
    form: {
      grupo: { required },
      filial: { required },
      tipo: { required },
      pesquisa: { required },
    },
  },
  watch: {
    filial() {
      this.listar();
    },
    atualizarPedido() {
      this.listar();
    },
    'form.tipo': function (tipo) {
      this.form.pesquisa = '';

      if (tipo === 2) {
        this.buscarFornecedores();
      }

      if (tipo === 3) {
        this.buscarSegmentos();
      }
    },
    atualizar_produtos_silenciados_count() {
      this.listar();
    }
  },
  created() {
    this.listar();
  },
  computed: {
    paginaItensAtual() {
      return Math.ceil(this.itens.length / this.itensPorPagina);
    },
    ...mapGetters({
      grupoCompras: "usuario/getGrupoCompras",
    })
  },
  methods: {
    atualizarCamposOrdenados(campos) {
      this.campos_em_ordenacao = campos;
      this.$forceUpdate();
    },
    resetarCarregamentoProdutos() {
      this.itens = [];
      this.todosItensPaginadosCarregados = false;
      this.getProdutosAposUmTempo();
    },
    getProdutosAposUmTempo() {
      this.loadingTable = true;
      clearTimeout(this.timerPesquisaKeyPress);
      this.timerPesquisaKeyPress = setTimeout(() => this.listar(), 1000);
    },
    buscarProdutosSeTiverNoFinalDaRolagem({scrollHeight, scrollTop, offsetHeight}) {
      if ((scrollTop + offsetHeight + 50) < scrollHeight || this.loadingTable) {
        return;
      }

      clearTimeout(this.timerScrollDataTable);
      this.timerScrollDataTable = setTimeout(() => this.listar(), 1000);
    },
    mensagensErros(campo) {
      const errors = [];
      if (!this.$v.form[campo].$dirty) return errors;
      !this.$v.form[campo].required && errors.push("Campo obrigatório.");
      return errors;
    },
    listar() {
      if (this.todosItensPaginadosCarregados) return;

      this.loadingTable = true;

      const parametros = {
        filial: this.filial,
        pagina: (this.paginaItensAtual + 1),
        itensPorPagina: this.itensPorPagina,
        pesquisa: this.pesquisa,
        id_unico_preferencia: this.id_unico_preferencia
      }

      this.$store.dispatch('loading/addRequisicao',
        buscarProdutosSileciados(parametros)
          .then(data => {
            this.itens  = this.itens.concat(data.itens);
            this.countTotal = data.countTotal;
            this.loadingTable = false;

            if (data.itens.length < this.itensPorPagina) {
              this.todosItensPaginadosCarregados = true;
            }
          })
          .catch(logout)
      );
    },
    salvar() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      const callback = data => {
        this.itens = data.itens;
        this.countTotal = data.countTotal;
        this.fechar();
      };

      const params = {
        ...this.form,
        new_request: {
          filial: this.filial,
          pagina: (this.paginaItensAtual + 1),
          itensPorPagina: this.itensPorPagina,
          pesquisa: this.pesquisa,
          id_unico_preferencia: this.id_unico_preferencia
        }
      }

      this.$store.dispatch(
        'loading/addRequisicao',
        salvarSilenciamentoProdutos(params).then(callback).catch(logout)
      );
    },
    excluir(prop) {
      if (!prop) {
        prop = { ids: arrayColumn(this.itensSelecionados, 'id') }
      }

      const params = {
        ...prop,
        filial: this.filial,
        pagina: (this.paginaItensAtual + 1),
        itensPorPagina: this.itensPorPagina,
        pesquisa: this.pesquisa,
        id_unico_preferencia: this.id_unico_preferencia
      }

      const callback = data => {
        this.itens = data.itens;
        this.countTotal = data.countTotal;
        this.itensSelecionados = [];
      };

      this.$store.dispatch(
        'loading/addRequisicao',
        excluirProdutosSileciados(params).then(callback).catch(logout)
      );
    },
    fechar() {
      this.form = {
        grupo: "",
        filial: "",
        tipo: "",
        pesquisa: "",
      };
      this.dialog = false;
      this.$v.$reset();
    },
    buscarFornecedores() {
      this.$store.dispatch(
        'loading/addRequisicao',
        buscarFornecedores().then(fornecedores => this.selects.pesquisa = fornecedores).catch(logout)
      );
    },
    buscarSegmentos() {
      this.$store.dispatch(
        'loading/addRequisicao',
        buscarSegmentos().then(segmentos => this.selects.pesquisa = segmentos).catch(logout)
      );
    }
  },
};
</script>
